import { render } from "./KPI.vue?vue&type=template&id=2d29bab2&scoped=true"
import script from "./KPI.vue?vue&type=script&lang=js"
export * from "./KPI.vue?vue&type=script&lang=js"

import "./KPI.vue?vue&type=style&index=0&id=2d29bab2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d29bab2"

export default script